import React from 'react'

function TemplatesTab() {
  return (
    <div>TemplatesTab</div>
  )
}

export default TemplatesTab